import {useQuery} from '@tanstack/react-query';
import axios from 'axios';

export const USE_LEGACY_INIT_KEY = 'init-key' as const;

// TODO: TYPES - update this type to match the actual response
// type InitProps = any;

export const useLegacyInit = ({
    encounterId,
    orgId,
    username,
}: {
    encounterId?: string;
    orgId: number;
    username: string;
}) =>
    useQuery(
        [USE_LEGACY_INIT_KEY, encounterId, orgId, username],
        () =>
            // axios.get<ApiResponse<InitProps>>(
            axios.get<ApiResponse<unknown>>(
                `organizations/${orgId}/patients/${username}/legacy/init/`,
                encounterId ?
                    {
                        params: {
                            encounterId,
                        },
                    }
                :   undefined,
            ),
        {
            refetchOnMount: 'always',
            select: ({data}) => data,
            staleTime: Infinity,
        },
    );
